module.exports = __webpack_public_path__ + "img/icon-big.c65e52a1.png";